import { notificationLabel, t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { Button } from '@repo/ui/button';
import { useState } from 'react';
import { dateLabel, OLink, Pagination, QueryState } from '@/components/raven/shared';
import { trpc } from '@/providers/trpc';
export const NotificationsPage = () => {
  useLocale();

  const [page, setPage] = useState(1);
  const utils = trpc.useUtils();
  const query = trpc.workspace.listNotifications.useQuery({ page }, { refetchInterval: 30000 });
  const mark = trpc.workspace.updateNotification.useMutation({
    onSuccess: () => {
      void utils.workspace.invalidate();
    },
  });
  return (
    <main className="raven-page">
      <span className="raven-label">{t('auth.activity')}</span>
      <h1>{t('workspace.notifications')}</h1>
      <p className="mb-7">
        {query.data?.unread ?? 0} {t('auth.unreadNotifications')}
      </p>
      <QueryState
        error={query.isError || mark.isError}
        loading={query.isLoading}
        retry={() => void query.refetch()}
      />
      <div className="space-y-3">
        {query.data?.data.map((notification) => (
          <article
            className="raven-panel flex flex-wrap items-center justify-between gap-4"
            key={notification._id}
          >
            <div>
              <p className={notification.readAt ? '' : 'font-semibold'}>
                {notificationLabel(notification)}
              </p>
              <span className="raven-muted">{dateLabel(notification.createdAt)}</span>
            </div>
            <div className="flex gap-4">
              <OLink to={`/reports/${notification.reportId}`}>{t('auth.viewReport')}</OLink>
              <Button
                disabled={mark.isPending}
                onClick={() =>
                  mark.mutate({
                    notificationId: notification._id,
                    data: { read: !notification.readAt },
                  })
                }
                size="sm"
                variant="ghost"
              >
                {notification.readAt ? t('auth.markUnread') : t('auth.markRead')}
              </Button>
            </div>
          </article>
        ))}
      </div>
      {query.data?.data.length === 0 && (
        <p className="raven-panel">{t('auth.noNotificationsYet')}</p>
      )}
      <Pagination onChange={setPage} page={page} totalPages={query.data?.totalPages ?? 1} />
    </main>
  );
};
